import { useState } from "react";
import styles from './AccountSelector.module.css';
import SingleSelectSearchableDropdown from "../../../Selectors/SingleSelectSearchableDropdown/SingleSelectSearchableDropdown";

const AccountSelector = ({
    userAccounts,
    setSelectedAccount,
    setShowAccountSelector
}) => {
    
    const [currentlySelectedAccount, setCurrentlySelectedAccount] = useState(null);

    const handleAccountSelect = (account) => {
        setCurrentlySelectedAccount(account);
    };

    const handleConfirm = () => {
        if (currentlySelectedAccount) {
            setSelectedAccount(currentlySelectedAccount);
            // setShowAccountSelector(false);
            // setShowPropertySelector(true);
        }
    };

    const handleCancel = () => {
        setShowAccountSelector(false);
    };

    // Transform userAccounts array to dropdown options format
    const accountOptions = userAccounts.map(account => ({
        id: account.name,
        displayText: account.displayName,
        label: account.name,
        iconText: `Region: ${account.regionCode} | Created: ${new Date(account.createTime).toLocaleDateString()}`
    }));

    return (
        <>
            <div className={styles.overlay} onClick={handleCancel} />
            <div className={styles.dialog}>
                <div className={styles.dialogHeader}>
                    <h3 className={styles.dialogTitle}>Choose Account</h3>
                </div>
                <div className={styles.dialogContent}>
                    <p className={styles.dialogDescription}>
                        Please select your Google Analytics account from the dropdown menu below.
                    </p>
                    <div className={styles.dropdownWrapper}>
                        <SingleSelectSearchableDropdown
                            fieldDisplayText="Select an account"
                            maxWidth={100}
                            maxWidthUnit="%"
                            listOptions={accountOptions}
                            labelPosition="BELOW"
                            setSelectedOption={handleAccountSelect}
                        />
                    </div>
                </div>
                <div className={styles.dialogFooter}>
                    <button className={styles.cancelButton} onClick={handleCancel}>
                        Cancel
                    </button>
                    <button 
                        className={styles.confirmButton} 
                        onClick={handleConfirm}
                        disabled={!currentlySelectedAccount}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </>
    );
}

export default AccountSelector;